module.exports = __webpack_public_path__ + "img/LowerPieceMoveS1Page.2ea52e6d.png";